<template>
  <v-container>
    <v-overlay v-model="overlay" color="white" opacity="1" persistent>
      <v-container style="text-align: center">
        <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
        <p class="pt-2" style="font-size: 14px; color: #234a98">{{ $t('common.loading') }}</p>
      </v-container>
    </v-overlay>
  </v-container>
</template>

<script>
export default {
  name: 'LogoutView',
  created() {
    localStorage.clear();
    // Reset delle proprietà critiche dello store per evitare che dati
    // della sessione precedente persistano nella navigazione SPA
    this.$store.state.userPreferences = { selectedCharts: [] };
    this.$store.state.userId = '';
    this.$store.state.userRole = '';
    this.$store.state.company = '';
    this.$store.state.userEmail = '';
    this.$store.state.userName = '';
    this.$store.state.tenantId = '';
    this.$store.state.permissions = { allowedAreas: '' };
    this.$store.state.timezone = 'Europe/Rome';
    this.overlay = false;
    this.$router.push({ path: "/" });
  },
  data() {
    return {
      overlay: false,
    };
  },
};
</script>